<div class="upsell-product-box p-4">
  <div class="upsell-product-box__container justify-center mx-auto w-full">

    <div *ngIf="productBoxTitle" class="upsell-product-box__title text-2xl text-center p-2" [innerHTML]="productBoxTitle"></div>
    <div class="upsell-product-box__wrapper">
      
      <div class="upsell-product-box__content p-4 flex flex-col items-center desktop:flex-row gap-6">
        
        <div class="upsell-product-box__image-wrapper basis-5/12 mx-auto flex flex-col justify-center desktop:flex-shrink-0">
          <img class="upsell-product-box__image max-h-72 w-auto self-center" src="{{ image }}" alt="{{ imageAlt }}">
        </div>
        
        <div class="upsell-product-box__description basis-7/12 text-center desktop:text-left">
          <div class=""> 
            <p *ngIf="productBoxSubtitle" class="upsell-product-box__subtitle text-2xl mb-2.5 text-bhmd-darkblue" [innerHTML]="productBoxSubtitle"></p>
            
            <div class="upsell-product-box__pricing text-xl placeholder:space-y-2">
              <div class="mb-2.5"><div class="h-px bg-black"></div></div>
              <p class="upsell-product-box__regularPrice notranslate">
                <span class="upsell-product-box__regularPrice-text">{{regularText}}: </span>
                <span class="upsell-product-box__regularPrice-number"> {{ regularPrice | dynamicCurrency:currency }}</span>
              </p>
            
              <p class="upsell-product-box__instantSavings text-xl notranslate">
                <span class="upsell-product-box__instantSavings-text bg-[#ff0]">{{instantSavingsText}}: </span>
                <span class="upsell-product-box__instantSavings-number bg-[#ff0]"> {{ instantSavings | dynamicCurrency:currency }}</span> 
              </p>
              <div class="mt-2.5"><div class="h-px bg-black"></div></div>
             
              <p class="upsell-product-box__yourPrice text-2xl pt-2.5 font-semibold notranslate"> 
                <span class="upsell-product-box__yourPrice-text">{{yourPriceText}}: </span>
                <span class="upsell-product-box__yourPrice-number text-bhmd-darkblue"> {{ yourPrice | dynamicCurrency:currency }} {{ currency !== 'USD' ? currency : '' }}</span>
              </p>
            </div>

            <div *ngIf="productBoxCTA" class="mt-6">
              <button 
                data-qa="cta-yes" 
                class="upsell-product-box__button-yes text-xl py-2.5 px-4 mb-4 rounded-full text-white font-bold leading-tight"
                (click)="nextPage(true)" 
                data-te="cta-yes" 
                [innerHTML]="buttonYesText">
              </button>

              <button 
                data-qa="cta-no" 
                class="upsell-product-box__button-no text-xl py-2.5 px-4 rounded-full leading-tight"
                (click)="nextPage(false)" 
                [innerHTML]="buttonNoText" 
                data-te="cta-no">
              </button>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>
